var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7l-.29-.71-1-1-.71-.29h-2l-.71,.29-1,1-.29,.71H3v2H12l.29,.71,1,1,.71,.29h2l.71-.29,1-1,.29-.71h3v-2h-3Zm-2,1.59l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Zm-5.29,5.71l-1-1-.71-.29h-2l-.71,.29-1,1-.29,.71H3v2h2l.29,.71,1,1,.71,.29h2l.71-.29,1-1,.29-.71h10v-2H11l-.29-.71Zm-1.71,2.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/1776855102/media/icon-filter.cae6d360dfcf4708fac55c3577e878b7.svg";
export { ForwardRef as ReactComponent };